"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var interface_1 = require("./interface");
var react_2 = require("react");
var userManager_1 = require("./userManager/userManager");
var initialState = { user: null };
var reducer = function (state, action) {
    switch (action.type) {
        case interface_1.actions.SET_USER:
            return __assign(__assign({}, state), { user: action.value });
        default:
            return state;
    }
};
exports.AuthContext = react_2.createContext(initialState);
exports.useSSOClient = function () { return react_2.useContext(exports.AuthContext); };
/**
 * AuthProvider checks if a user is authenticated and shares that data down the tree of react components through the `useSSOClient` hook.
 * @param loadingComponent
 * What loading component to show while checking users authentication.
 */
exports.AuthProvider = function (_a) {
    var children = _a.children, loadingComponent = _a.loadingComponent;
    var _b = react_1.useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var _c = react_1.useState(true), loading = _c[0], setLoading = _c[1];
    var userManager = userManager_1.UserManager.getInstance();
    var Loader = loadingComponent;
    var value = {
        user: state.user,
        setUser: function (value) {
            dispatch({ type: interface_1.actions.SET_USER, value: value });
        }
    };
    /**
     * Makes call to userManager and tries to retrieve a user.
     * Then sets that user to state where it can be consumed through `useSSOClient`.
     */
    var loadUser = function () { return __awaiter(void 0, void 0, void 0, function () {
        var user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userManager.getUser()];
                case 1:
                    user = _a.sent();
                    if (user) {
                        saveTokenInLocalStorage(user.access_token);
                    }
                    value.setUser(user);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        if (!value.user) {
            loadUser();
        }
    }, []);
    // When silent renewal happens, this event listener will add the new users token to local storage.
    userManager.events.addUserLoaded(function (newUser) {
        saveTokenInLocalStorage(newUser.access_token);
    });
    return (react_1.default.createElement(exports.AuthContext.Provider, { value: value },
        loading && react_1.default.createElement(Loader, null),
        !loading && children));
};
var saveTokenInLocalStorage = function (token) {
    if (!localStorage.getItem("access_token")) {
        localStorage.setItem("access_token", token);
    }
    else {
        localStorage.removeItem("access_token");
        localStorage.setItem("access_token", token);
    }
};
//# sourceMappingURL=authProvider.js.map